/**
 * Custom hook to get the current application version
 * @returns {string} The current app version from package.json
 */
export const useAppVersion = (): string => {
  return __APP_VERSION__;
};

/**
 * Utility function to get app version (can be used outside React components)
 * @returns {string} The current app version from package.json
 */
export const getAppVersion = (): string => {
  return __APP_VERSION__;
};
